export default __webpack_public_path__ + "static/media/windows.d70279cc.svg";